module.exports = __webpack_public_path__ + "img/banner-inscreva-se.6f4d83f0.png";